type TOfferSectionProps<T> = {
  title: string
  items: T[]
  getLabel: (item: T) => string
}

const renderListValues = <T,>(
  values: T[],
  getLabel: (item: T) => string,
): React.ReactNode => {
  if (values.length > 0) {
    return (
      <ul className="tw:list-disc">
        {values.map((item, index) => (
          <li key={getLabel(item) + index}>{getLabel(item)}</li>
        ))}
      </ul>
    )
  }

  return <p className="tw:text-muted-foreground">None available</p>
}

export const OfferPromoAndLoyaltyProgramSection = <T,>({
  title,
  items,
  getLabel,
}: TOfferSectionProps<T>) => (
  <div>
    <p className="tw:font-medium">{title}</p>
    {renderListValues(items, getLabel)}
  </div>
)
